exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Box{\r\n\tposition:fixed;\r\n\tbottom:0px;\r\n\r\n\t}\r\n\r\n", ""]);
